import React, { useRef, useEffect, useImperativeHandle, forwardRef  } from 'react';
import { Box, Button, CssBaseline } from "@mui/material";
import { DefaultCard } from "../../assets/styled-components/card";
import { jsPDF } from "jspdf";
import html2canvas from 'html2canvas';
import { useReactToPrint } from 'react-to-print';
import Assetreportform from './Assetreportform';
import { ThemeProvider as MuiThemeProvider } from "@mui/material/styles";
import { defaultLightTheme } from "../../assets/styled-components/themes/themelist";
import { useSelector } from "react-redux";
import { useAccess } from "../../AccessContext";
import utilities from '../../utility/utilities';

const AssetcyclePrint =forwardRef((props, ref) => {
    
    const {reportdata, setOpenModal, onRenderComplete, autoDownload }= props;
    const { color } = useSelector((state) => state.theme);
    const printRef = useRef();
    const accessData = useAccess();
    const access = utilities.getScreenPermissions(accessData, "ENGA004");

    const handlePrint = useReactToPrint({
        content: () => printRef.current,
    });

    const handleDownloadPDF = () => {
        html2canvas(printRef.current, {
            scale: 2,
            useCORS: true,
        }).then(canvas => {
            const imgData = canvas.toDataURL('image/png');
            const pdf = new jsPDF({
                orientation: 'p',
                unit: 'mm',
                format: [210, 297],
            });

            const pdfWidth = pdf.internal.pageSize.getWidth();
            const pdfHeight = pdf.internal.pageSize.getHeight();
            const imgWidth = canvas.width * 0.264583; // Convert canvas pixels to mm
            const imgHeight = canvas.height * 0.264583; // Convert canvas pixels to mm

            const widthRatio = pdfWidth / imgWidth;
            const heightRatio = pdfHeight / imgHeight;
            const ratio = Math.min(widthRatio, heightRatio);

            const width = imgWidth * ratio;
            const height = imgHeight * ratio;
            const x = (pdfWidth - width) / 2;
            const y = (pdfHeight - height) / 2;

            pdf.addImage(imgData, 'PNG', x, y, width, height);
            pdf.save("Asset_lifecycle_Cost_Analysis_Report.pdf");
        }).catch(error => {
            console.error("Error generating PDF:", error);
        });
    };

    const handleClose = () => {
        setOpenModal(false);
    };
    useImperativeHandle(ref, () => ({
        handleDownloadPDF,

    }));
    
    useEffect(() => {
        if (onRenderComplete) {
            onRenderComplete();
        }
    }, [onRenderComplete]);
    useEffect(() => {
        if (autoDownload && reportdata) {
          handleDownloadPDF();
       
        }
      }, [reportdata, autoDownload]);

    return (
        <MuiThemeProvider
        theme={{
          ...defaultLightTheme,
          palette: {
            ...defaultLightTheme.palette,
            background: {
              default: color !== "default" && "rgba(17, 17, 17, 1)",
            },
          },
        }}
      >
            <CssBaseline />
            <DefaultCard mt={{ xs: 1, sm: 2 }}>
                <Box sx={{ width: '100%' }}>
                    <Box sx={{
                        display: 'flex',
                        gap: 1,
                        justifyContent: { xs: 'center', md: 'flex-end' },
                        marginBottom: 2,
                        marginTop: 3
                    }}>
                        {access?.canPrint && (<>
                            <Button variant='contained' onClick={handlePrint}>Print</Button>
                            <Button variant='contained' onClick={handleDownloadPDF}>Download</Button>
                        </>)}
                        <Button variant='contained' onClick={handleClose}>Close</Button>
                    </Box>
                </Box>
                <Assetreportform ref={printRef} reportdata={reportdata} className="pdf-content" />
            </DefaultCard>
        </MuiThemeProvider>
    );
});

export default AssetcyclePrint;
